<template>
  <div class="richText-details">
    <b-container>
      <b-row>
        <div class="breadcrumb">
          <div class="label">当前位置：</div>
          <div class="label">
            <span class="title" @click="to('/')">首页</span>
          </div>
          <div class="label" v-if="isMenu">
            <span class="icon"
              ><b-icon icon="chevron-right"></b-icon
              ><b-icon icon="chevron-right"></b-icon
            ></span>
            <span class="title" @click="navTo(isMenu, isMenu)">{{
              isMenu.name
            }}</span>
          </div>
          <div class="label" v-if="isMenu.children && menuKey">
            <template v-for="(item, index) in isMenu.children">
              <div
                v-if="item.id == menuKey"
                @click="navTo(item, isMenu)"
                :key="index"
              >
                <span class="icon"
                  ><b-icon icon="chevron-right"></b-icon
                  ><b-icon icon="chevron-right"></b-icon></span
                ><span class="title">{{ item.name }}</span>
              </div>
            </template>
          </div>
          <div class="label">
            <span class="icon"
              ><b-icon icon="chevron-right"></b-icon
              ><b-icon icon="chevron-right"></b-icon
            ></span>
            <span class="title">正文</span>
          </div>
        </div>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col :xl="3">
          <div class="left-navigation">
            <b-list-group>
              <b-list-group-item v-if="isMenu" style="background: #f9f9f9">
                {{ isMenu.name }}
              </b-list-group-item>
              <b-list-group-item
                v-for="(item, index) in isMenu.children"
                :key="index"
                @click="navTo(item, isMenu)"
                href="#"
                >{{ item.name }}</b-list-group-item
              >
            </b-list-group>
            <!-- 继续教育 -->
            <div class="jxjy">
              <img src="@/assets/img/advertising.png" />
            </div>
            <!-- 快速通道 -->
            <div class="kstd-block">
              <div class="title">
                <div class="icon">
                  <img src="@/assets/img/kuaisutongdao.png" />
                </div>
                快速通道
              </div>
              <div class="kstd" v-if="kstdList && kstdList.length > 0">
                <div
                  class="black"
                  v-for="(item, index) in kstdList"
                  :key="index"
                  @click="kstdTo(item)"
                >
                  <div class="img">
                    <img :src="baseURL + '/' + item.url" />
                  </div>
                  <div class="label">{{ item.name }}</div>
                </div>
              </div>
              <div class="kstd noData" v-else>无相关数据</div>
            </div>
          </div>
        </b-col>
        <b-col class="pl-0" :xl="9">
          <div class="docx">
            <div class="title">{{ info.title }}</div>
            <div class="docxData">
              <div class="label">
                <!-- <span v-if="info.type == 0">常规文章</span> -->
                <span v-if="info.type == 1">学校要闻</span>
                <span v-if="info.type == 2">学校新闻</span>
                <span v-if="info.type == 3">通知公告</span>
                <span v-if="info.type == 4">招生就业</span>
                <span v-if="info.type == 5">培训动态</span>
                <span v-if="info.type == 6">校园风采</span>
                <span v-if="info.type != 0 && !info.type">{{
                  info.typeName || ""
                }}</span>
              </div>
              <div class="label">{{ info.createTime }}</div>
              <div class="label">阅读量：{{ info.views || 0 }}</div>
            </div>
            <div class="richText" v-html="info.richText"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { request, baseURL } from "@/utils/http";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      info: {},
      baseURL,
      isMenu: this.$store.state.isMenu,
      menuKey: this.$store.state.menuKey,
      kstdList: this.$store.state.kstdList,
    };
  },
  async beforeRouteUpdate(to, from, next) {
    const res = await request({
      url: `/web/ArticleController/selectOne/${to.params.id}`,
      method: "get",
    });
    //获取菜单栏
    this.info = res.data;
    next();
  },
  async created() {
    const res = await request({
      url: `/web/ArticleController/selectOne/${this.$route.params.id}`,
      method: "get",
    });
    //获取菜单栏
    this.info = res.data;
  },
  methods: {
    ...mapMutations(["upIsMenu", "upMenuKey"]),
    to(e) {
      this.$router.push(e);
    },
    kstdTo(e) {
      //快速通道点击事件
      if (e.type == 0 && e.path) {
        //内部链接
        this.$router.push(e.path);
      }
      if (e.type == 1 && e.path) {
        //外部链接
        window.open(e.path);
      }
      if (e.type == 2 && e.docxId) {
        //文章
        this.$router.push({
          name: "richText-id",
          params: { id: e.docxId },
        });
      }
    },
    navTo(e, item) {
      if (e.jump == 0) {
        this.upIsMenu(item);
        this.upMenuKey(e.id);
        if (e.type == 0 && e.path) {
          //内部链接
          this.$router.push(e.path);
        }
        if (e.type == 1 && e.path) {
          //外部链接
          window.open(e.path);
        }
        if (e.type == 2 && e.docxId) {
          //文章
          this.$router.push({
            name: "richText-id",
            params: { id: e.docxId },
          });
        }
        if (e.type == 3 && e.path) {
          //其他
          this.$router.push(e.path);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.richText-details {
  .breadcrumb {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
    background: none;
    font-size: 16px;
    padding: 15px 0;
    .label {
      margin-right: 5px;
      .title {
        cursor: pointer;
      }
    }
    .icon {
      font-size: 10px;
      margin-right: 5px;
    }
  }
  .left-navigation {
    margin-bottom: 20px;
    .list-group-item {
      text-align: center;
    }
    .jxjy {
      margin-top: 15px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    .kstd-block {
      margin-top: 15px;
      background: white;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 15px 15px 0 15px;
      overflow: hidden;
      .title {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid $gray-4;
        padding-bottom: 5px;
        .icon {
          width: 18px;
          margin-right: 5px;
          display: inline-block;
          img {
            width: 100%;
          }
        }
      }
      .kstd {
        min-height: 220px;
        padding-bottom: 15px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        .black {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 15px;
          .img {
            width: 60px;
            height: 60px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .label {
            padding-top: 10px;
            font-size: 12px;
            text-align: center;
          }
        }
        .black:hover {
          cursor: pointer;
          .label {
            color: $theme-5;
          }
        }
      }
    }
  }
  .docx {
    box-sizing: border-box;
    border: 1px solid $gray-5;
    background: white;
    padding: 20px;
    margin-bottom: 20px;
    min-height: 600px;
    .title {
      font-size: 24px;
      color: $gray-8;
      text-align: center;
      font-weight: bold;
    }
    .docxData {
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: $gray-7;
      margin: 20px 0;
      .label {
        margin-right: 15px;
      }
    }
    .richText {
      width: 100%;
      img {
        max-width: 100%;
      }
      /* table 样式 */
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        td,
        th {
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
          padding: 3px 5px;
          text-align: center;
        }
      }
    }
  }
}
</style>